module.exports = __webpack_public_path__ + "img/restore-card2.b2d07693.svg";